/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Metrics_Export_Complete_ToastInputs */

const en_speakers_metrics_export_complete_toast = /** @type {(inputs: Speakers_Metrics_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker metrics exported`)
};

const fr_speakers_metrics_export_complete_toast = /** @type {(inputs: Speakers_Metrics_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker metrics exported`)
};

const de_speakers_metrics_export_complete_toast = /** @type {(inputs: Speakers_Metrics_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker metrics exported`)
};

const it_speakers_metrics_export_complete_toast = /** @type {(inputs: Speakers_Metrics_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker metrics exported`)
};

const ru_speakers_metrics_export_complete_toast = /** @type {(inputs: Speakers_Metrics_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker metrics exported`)
};

const es_speakers_metrics_export_complete_toast = /** @type {(inputs: Speakers_Metrics_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker metrics exported`)
};

const zh_cn2_speakers_metrics_export_complete_toast = /** @type {(inputs: Speakers_Metrics_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker metrics exported`)
};

const ja_speakers_metrics_export_complete_toast = /** @type {(inputs: Speakers_Metrics_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker metrics exported`)
};

const hi_speakers_metrics_export_complete_toast = /** @type {(inputs: Speakers_Metrics_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker metrics exported`)
};

const pt_pt2_speakers_metrics_export_complete_toast = /** @type {(inputs: Speakers_Metrics_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker metrics exported`)
};

/**
* | output |
* | --- |
* | "Speaker metrics exported" |
*
* @param {Speakers_Metrics_Export_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_export_complete_toast = /** @type {((inputs?: Speakers_Metrics_Export_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Export_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_metrics_export_complete_toast(inputs)
	if (locale === "de") return de_speakers_metrics_export_complete_toast(inputs)
	if (locale === "it") return it_speakers_metrics_export_complete_toast(inputs)
	if (locale === "ru") return ru_speakers_metrics_export_complete_toast(inputs)
	if (locale === "es") return es_speakers_metrics_export_complete_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_metrics_export_complete_toast(inputs)
	if (locale === "ja") return ja_speakers_metrics_export_complete_toast(inputs)
	if (locale === "hi") return hi_speakers_metrics_export_complete_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_metrics_export_complete_toast(inputs)
	return en_speakers_metrics_export_complete_toast(inputs)
});